import { timelineAddComponent } from './timeline-add.component';

import '../timeline.scss';

export const timelineAdd = angular
	.module('components.timeline.timelineAdd', [])
	.component('timelineAdd', timelineAddComponent)
	.config(($stateProvider) => {
		'ngInject';

		$stateProvider
			.state('timelineAdd', {
				parent: 'app',
				url: '/home/timeline/add',
				breadcrumbName: 'Add new',
				parentState: 'timeline',
				component: 'timelineAdd',
			})
			.state('spouseChecklistAdd', {
				parent: 'app',
				url: '/home/spouse-checklist/add',
				breadcrumbName: 'Add new',
				parentState: 'spouseChecklist',
				component: 'timelineAdd',
			});
	})
	.name;


// WEBPACK FOOTER //
// ./src/app/components/timeline/timeline-add/timeline-add.module.js